import couponsOnProducts from "./couponsOnProducts";
import couponsWithDiscount from "./couponsWithDiscount";
import couponsWithCode from "./couponsWithCode";
import couponsWithTransactions from "./couponsWithTransactions";
import couponsWithVisits from "./couponsWithVisits";

export default {
    namespaced: true,

    modules: {
        couponsOnProducts,
        couponsWithDiscount,
        couponsWithCode,
        couponsWithTransactions,
        couponsWithVisits
    },
};
